let content = [
    {
      id: "general_trading_conditions",
      title: "一般交易條件",
      tabs: [
        {
          //id: "product_details",
          id:"tc-view-6",
          title: "產品詳情",
          content_before: `<p class="mb-5">
                              iFOREX 為基於各種基礎資產（「基礎資產」）的差價合約槓桿保證金交易提供極具競爭力的條件，包括貨幣對（外匯）、商品、指數、股票、ETF 和加密貨幣（「工具」或“金融工具」或「槓桿工具」或「差價合約」（視上下文而定）。
                                <br><br>
                                <b>點差</b><br>點差是交易成本——它是賣出（買入）價格和買入（賣出）價格之間的差額。例如，如果美元/日元以 101.202 的賣出價和 101.222 的買入價交易，這兩個價格之間的差額稱為點差。在這種情況下，點差為 2 點。
                                <br><br>
                                <b>保證金和槓桿</b><br>在交易槓桿工具時，雖然“保證金”作為抵押品來彌補您可能遭受的任何損失，但它還允許您持有比您的實際帳戶價值大得多的頭寸，讓您有可能產生相對於金額的巨額利潤投資。
                                <br><br>
                                槓桿是一把雙刃劍，可以顯著放大您的利潤，但也可以輕易放大您的損失。當您使用過度槓桿時，虧損交易會迅速抵消許多盈利交易。槓桿交易具有高度風險，未必適合所有投資者。
                                <br><br>
                                作為 iFOREX 帳戶持有人，您有權享受我們的負餘額保護計劃，這意味著您的損失永遠不會超過您的存款；然而，市場的小幅波動可能導致大量資金損失。我們的交易平台會在執行任何訂單之前自動計算您的保證金要求，並在提出任何提款請求之前檢查可用資金水平。
                                <br><br>
                                保證金要求與透過開倉/平倉交易或在帳戶中持有未平倉部位時請求提取資金來增加帳戶風險敞口相關。保證金要求反映了任何給定資產的基於波動性、流動性和定價可用性的頭寸潛在風險。
                              </p>
                           <span id="product_section"></span>
                            <p class="tc-inner-link"><a href="/交易條件/貨幣">貨幣</a></p>
                            <p class="tc-inner-link"><a href="/交易條件/大宗商品">大宗商品</a></p>
                            <p class="tc-inner-link"><a href="/交易條件/指數">指數</a></p>
                            <p class="tc-inner-link"><a href="/交易條件/股票">股票</a></p>
                            <p class="tc-inner-link"><a href="/交易條件/etf">ETFs</a></p>
                            <p class="tc-inner-link"><a href="/交易條件/加密貨幣">加密貨幣</a></p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "trading_hours",
          id: "tc-view-2",
          title: "交易時間",
          content_before: `<p>
                在歐洲和北美冬季，每週活動從格林威治標準時間週日 22:05 開始，一直持續到格林威治標準時間週五 21:00。在這些地區的夏令時期間，每週市場活動從格林威治標準時間週日 21:05 開始，到週五 20:00 結束。市場活動時間可能會因公眾假期或因全球特殊事件引起的異常流動性狀況而有所不同。出於流動性和風險管理的考慮，iFOREX 也可能更改開盤或收盤時間。
                <br><br>
                儘管大多數工具都是 24 小時不間斷交易，但有些工具有特殊的交易時間，如下表所示：
                </p>`,
  
          data_id: "TradingHours",
          products: {
            1:"貨幣和加密貨幣",
            2:"大宗商品",
            3:"指數",
            4:"股票",
            5:"Metals",
            8:"ETF"
          },
          table_titles: [
            "市場",
            "交易時間 (GMT)",
            "第一個每日休息時間 (GMT)",
            "第二個每日休息時間 (GMT)",
            "數據有效期至 (GMT)"
          ],
          content_after: `<p>不確定哪個市場包含您正在尋找的工具？點擊<span class="tclink" target-tab="tc-view-6">此處</span>查看每個市場的完整工具列表。</p>`,
        },
        {
          //id: "holidays",
          id: "tc-view-4",
          title: "節假日",
          content_before: `<p>
                            為確保您了解所有市場時間和節假日，請在下方查看可能更改交易時間的事件列表。<br>
                            在 iFOREX，我們盡最大努力更新這些信息。<br>
                            如果您希望獲得更多信息，請隨時聯繫我們的交易台。
                        </p>`,
  
          data_id: "Holidays",
          table_titles: [
            "市場",
            "(格林威治標準時間) 停牌",
            "(GMT) 恢復交易",
          ],
          content_after: `<p>不確定哪個市場包含您正在尋找的工具？點擊<span class="tclink" target-tab="tc-view-6">此處</span>查看每個市場的完整工具列表。</p>`,
        },
        {
          //id: "orders_and_execution",
          id: "tc-view-23",
          title: "訂單和執行",
          content_before: ` <p><b>訂單類型</b></p>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>市場訂單</th>
                   <th></th>
                </tr>
                <tr>
                   <td>公開交易</td>
                   <td>以當前可用市場價格開倉的訂單</td>
                </tr>
                <tr>
                   <td>成交</td>
                   <td>以當前可用市場價格平倉的訂單</td>
                </tr>
             </tbody>
          </table>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>限購單</th>
                   <th></th>
                </tr>
                <tr>
                   <td>止損</td>
                   <td>止損是一種以低於當前市場價格的價格開倉或平倉的訂單</td>
                </tr>
                <tr>
                   <td>獲利</td>
                   <td>止盈是一種以高於當前市場價格的價格打開或關閉交易的訂單</td>
                </tr>
             </tbody>
          </table>
          <p>
             <b>市價單</b><br>市價單（交易請求）將以執行時公司伺服器所顯示的價格（「市場價格」）執行，該價格可能與交易平台（客戶端）所顯示的價格不同。如果市場價格與交易平台所顯示的價格存在重大差異 - 例如，由於客戶下訂單至訂單被接收並執行期間標的資產價格發生變動、市場高度波動或通訊延遲等原因 - 則無論市場價格高於還是低於交易平台所顯示的價格，訂單都將被拒絕。
          </p>
          <p>
             <b>限價單</b><br>限價訂單（未來訂單）以公司服務器上更新的市場價格執行，可能與訂單中指示的價格不同（“滑點”）。如果訂單中指示的價格在服務器中不可用，例如由於市場價格的高波動性和差距，可能會發生滑點。在這種情況下，訂單將以第一個可用價格執行，無論滑點的方向如何，無論是否對客戶有利，均以對稱和透明的方式（對稱滑點）執行。<br><br>非 24 小時交易的工具（例如股票、指數和 ETF 差價合約）可能每天都會出現市場缺口，因此更容易出現滑點。請務必注意，滑點不會影響負餘額保護，因此即使發生滑點，客戶的損失也不會超過投資金額（包括任何利潤，如果獲得）。
          </p>
          <p>
             <b>執行延遲</b><br>執行延遲可能因各種原因而發生，例如客戶的網絡、手機網絡或其他與 iFOREX 服務器的通信連接的技術問題，這可能導致“掛單”。連接路徑中的干擾有時會中斷信號並禁用平台，從而導致交易者平台和 iFOREX 服務器之間的數據傳輸延遲。
          </p>
          <p>
             <b>掛單</b><br>在交易量大或通信延遲期間，可能會出現掛單，這意味著限價單已經下達，但它只是需要一些時間來確認/處理。在交易量大或通信延遲期間，可能會形成限價訂單隊列。傳入訂單的增加有時可能會造成確認/處理某些限價訂單出現延遲的情況。在某些情況下，倉位實際上可能已經被執行，並且由於網絡流量過大，延遲只是在客戶端的顯示中。<br><br>請記住，任何訂單只需輸入一次。同一訂單的多個條目可能會減慢或鎖定您的電腦或無意中打開不需要的頭寸。
          </p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "negative_balance_protection",
          id: "tc-view-20",
          title: "負餘額保護",
          content_before: `<p>
                iFOREX 的負餘額保護政策保證客戶的損失僅限於投資於客戶帳戶的資金。根據該政策，客戶在 iFOREX 進行交易時絕不會因交易損失而面臨借方餘額，客戶的潛在損失僅限於存入客戶帳戶的資金和客戶獲得的資金（如有）。
              </p>`,
          data_id: "",
          content_after: "",
        },
        {
          //id: "bonus_terms_and_conditions",
          id:'btc',
          title: "獎金條款和條件",
          content_before: `
          <p><b>介紹</b><br>這些紅利條款和條件是關於交易紅利的，包括公司提供的歡迎紅利、現金返還紅利和試用帳戶紅利（以下簡稱“紅利”），詳情如下，並被視為不可分割的一部分公司的條款和條件。此處包含的所有條款解釋均在公司網站 <a href="/">www.iforex.tw</a> 上提供的公司條款和條件中進行解釋。</p>
          <p>
             <b>資格條件</b><br>符合相關優惠的資格標準、根據公司要求通過所有必需的註冊程序並被公司批准為合資格的公司客戶可獲得獎金（即“<b>合格客戶</b>”）。
             <br><br>
             公司全權酌情向其認為適當的任何客戶和/或國家/地區提供任何獎金。
             <br><br>
             公司保留自行決定拒絕任何用戶，包括合格客戶的註冊贈金和/或自行決定撤銷任何贈金的權利。<br><br>來自受限司法管轄區的居民，包括美國居民，沒有資格獲得交易紅利。
          </p>
          <p><b>交易紅利</b><br>根據本協議的一般條款，交易贈金將按其交易帳戶中存入資金金額的百分比和/或公司全權酌情認為合適的其他方式授予合格客戶。
             <br><br>
             交易贈金僅用於保證金交易，因此只能用作額外保​​證金,(即客戶無法提取授予的贈金）
             <br><br>
             每個合格客戶將被授予交易紅利。
             <br><br>
             歡迎獎金 - 是第一次入金客戶的交易獎金。
          </p>
         
                      <ul class="list-style-dashed">
                      <li class="mt-1 mb-2">如發生任何資金提取，包括將資金轉入 Vault（保險庫），公司可自行決定全部或部分撤銷及取消已發放的任何獎金。</li>
                      </ul>
          <u style="font-style:italic">例子</u><br><br>
          符合條件的客戶同意公司將在其 1,000 美元的存款中獲得 30% 的獎金。符合條件的客戶將獲得 300 美元的額外保證金（即其存款的 30%）作為交易紅利。<br><br>此獎金將反映在客戶的帳戶中，如下所示：
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>帳戶餘額</th>
                      <th>資産淨值</th>
                      <th>可用保證金</th>
                      <th>交易紅利</th>
                   </tr>
                   <tr>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$1,300</td>
                      <td>$300</td>
                   </tr>
                </tbody>
             </table>
          </div>
          交易贈金在任何時候都不可提取。符合條件的客戶可以根據公司的提款政策和適用規定提取通過使用交易贈金獲得的任何利潤。從交易贈金中提取的可提取利潤將在客戶帳戶的“帳戶餘額”部分可見。
          <br><br>
          <u style="font-style:italic">例子</u><br><br>
          符合條件的客戶同意公司將在其 1,000 美元的存款中獲得 30% 的獎金。合格客戶在其帳戶中擁有以下淨值和餘額：
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>帳戶餘額</th>
                      <th>資産淨值</th>
                      <th>可用保證金</th>
                      <th>交易紅利</th>
                   </tr>
                   <tr>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$1,300</td>
                      <td>$300</td>
                   </tr>
                </tbody>
             </table>
          </div>
          <u style="font-style:italic">情況 A</u><br><br>
          客戶已要求提取其全部存款（1,000 美元）。交易紅利將被完全刪除。<br><br>這將反映在客戶的帳戶上，如下所示：
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>帳戶餘額</th>
                      <th>資産淨值</th>
                      <th>可用保證金</th>
                      <th>交易紅利</th>
                   </tr>
                   <tr>
                      <td>$0</td>
                      <td>$0</td>
                      <td>$0</td>
                      <td>$0</td>
                   </tr>
                </tbody>
             </table>
          </div>
          <u style="font-style:italic">情況 B</u><br><br>
          客戶申請提取 <b>800 美元</b>，因此客戶的淨值降至 <b>200 美元</b>，在這種情況下，<b>交易紅利將被移除</b>。
          <br><br>這將反映在客戶的帳戶上，如下所示：
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>帳戶餘額</th>
                      <th>資産淨值</th>
                      <th>可用保證金</th>
                      <th>交易紅利</th>
                   </tr>
                   <tr>
                      <td>$200</td>
                      <td>$200</td>
                      <td>$200</td>
                      <td>$0</td>
                   </tr>
                </tbody>
             </table>
          </div>
          若帳戶連續30天處於非活躍狀態，所有交易獎金將被取消。
          <br><br>
          <p><b>返現</b><br>
             CashBack 計劃將依每周交易金額達到公司所預設的門檻而將相應將現金記入合格客戶的帳戶（“待定紅利”）。<br><br>待定紅利金額可能來自某筆或多筆存款，按存款價值的百分比計算，或由公司自行決定。
          </p>
          <u style="font-style:italic">例子</u><br><br>
          存入 1,000 美元的合格客戶有權在交易量為 20,000,000 美元時獲得最高 40% 的存款價值作為現金返還。此類客戶將獲得 400 美元的待定紅利。<br><br>這將反映在客戶的帳戶上，如下所示：
          <div class="table-wrapper">
             <table class="table2 mt-3 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>帳戶餘額</th>
                      <th>資産淨值</th>
                      <th>可用保證金</th>
                      <th>待定紅利</th>
                      <th>歷史交易額</th>
                      <th>所需交易額</th>
                   </tr>
                   <tr>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$400</td>
                      <td>$0</td>
                      <td>$20,000,000</td>
                   </tr>
                </tbody>
             </table>
          </div>
          我們將會每周將已實現返現金額於總返現金額(待定紅利)中扣除，該比例是根據客戶的當周交易量與表定的所需交易額比例來計算(依美金)。客戶僅有權獲得已實現返現金額，而待定紅利僅在客戶完成所需交易數量後才能實現。返回現金金額（“已實現返現”）僅限於分配給客戶的待定紅利。<br><br>交易量以“進出”為基礎計算，這意味著開立 100 萬美元（或其他等值貨幣）頭寸和平倉相同頭寸，總計為滿足了 200 萬美元（或其他等值貨幣）的交易量要求。
          <br><br>
          <u style="font-style:italic">例子</u><br><br>
          <u style="font-style:italic">情況 A</u><br><br>
          上例中的合格客戶每交易 5,000,000 美元即可獲得 100 美元的已實現返現金額。 1 週後，他達到了 5,000,000 美元的交易量。因此，作為已實現現金返還的 100 美元已從待定紅利轉移到資產淨值。<br><br>這將反映在客戶的帳戶上，如下所示：
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>帳戶餘額</th>
                      <th>資産淨值</th>
                      <th>可用保證金</th>
                      <th>待定紅利</th>
                      <th>歷史交易額</th>
                      <th>所需交易額</th>
                   </tr>
                   <tr>
                      <td>$1,100</td>
                      <td>$1,100</td>
                      <td>$1,100</td>
                      <td>$300</td>
                      <td>$5,000,000</td>
                      <td>$20,000,000</td>
                   </tr>
                </tbody>
             </table>
          </div>
          <u style="font-style:italic">情況B</u><br><br>
          存款兩週後，客戶的交易獲得了 300 美元的利潤，並且交易量達到了 5,000,000 美元，另外100美元的已實現返現金額將從待定紅利轉移到資產淨值。<br><br>這將反映在客戶的帳戶上，如下所示：
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>帳戶餘額</th>
                      <th>資産淨值</th>
                      <th>可用保證金</th>
                      <th>待定紅利</th>
                      <th>歷史交易額</th>
                      <th>所需交易額</th>
                   </tr>
                   <tr>
                      <td>$1,500</td>
                      <td>$1,500</td>
                      <td>$1,500</td>
                      <td>$200</td>
                      <td>$10,000,000</td>
                      <td>$20,000,000</td>
                   </tr>
                </tbody>
             </table>
          </div>
          在計入資產淨值後，已實現返現金額將可用於交易或可由客戶隨時提取。投資已實現返現金額所獲得的任何利潤也可以供提取。<br><br>返現促銷是有時間限制的，客戶在獲得待定紅利的前 3 個月可以收到已實現返現金額。當他進一步存款時，客戶有資格獲得更多現金返還。
          <br><br>
          <u style="font-style:italic">例子</u><br><br>
          前面示例中的合格客戶決定提取他的 300 美元利潤和收到的 200 美元已實現現返現金額。因此，他要求總共提取 500 美元。剩餘的 200 美元現金返還贈金將作為待定紅利保留在他的帳戶中，因此客戶仍然可以使用 1,000 美元繼續交易，並且還有兩個半月的時間將待定紅利轉換為已實現返現金額。<br><br>這將反映在客戶的帳戶上，如下所示：
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>帳戶餘額</th>
                      <th>資産淨值</th>
                      <th>可用保證金</th>
                      <th>待定紅利</th>
                      <th>歷史交易額</th>
                   </tr>
                   <tr>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$200</td>
                      <td>$10,000,000</td>
                   </tr>
                </tbody>
             </table>
          </div>
          所有現金返還都以帳戶的幣種提供。
          <br><br>
          <p>
             <b>試用帳戶</b><br>
             根據公司的交易條件，用戶可能會獲得一個包含 125 美元交易贈金（如上所述）的試用帳戶，可用於交易。
             <br><br>
             試用帳戶將於試用帳戶中進行第一筆交易之日起 3 天內到期，且試用帳戶中的所有待處理交易均應終止（「試用期」）。 任何超過 25 美元（「利潤」）的金額均可作爲用戶在公司的交易帳戶的保證金，但前提是用戶成功完成公司註冊流程且最低存款為 100 美元，又或者提取至用戶名下的銀行帳戶。但請注意，(i) 提款須遵守公司的提款流程，並可能進一步產生收取轉帳費用， (ii) 自試用帳戶開設第一筆交易之日起 14 天內未提取或轉入交易帳戶並用作交易保證金的任何利潤將被撤銷。
             <br><br>
             此獎勵僅適用於首次在公司平台註冊並符合上述資格標準的客戶。每個住宅位址/家庭/IP位址僅限領取一份獎勵。客戶開立多個帳戶，或使用同一住宅地址/家庭/IP地址註冊多個帳戶，均視為違反本條款。在此情況下，除使用該住宅地址/家庭/IP地址註冊的第一個帳戶外，所有其他帳戶產生的獎勵及收益將被取消。此限制同樣適用於直系親屬開立的帳戶。只有第一個此類帳戶符合領取獎勵的資格，任何後續帳戶產生的獎勵及收益將被取消。
          </p>
          <p>
             <b>一般條款</b><br>
             公司酌情決定如有任何跡像或懷疑以任何形式的非法、不公平和/或濫用交易方法或行為（包括但不限於表明旨在從交易紅利中獲得經濟利益而不承擔市場風險的交易活動模式和\\或通過為每位客戶開設、運營或管理多個帳戶）以及任何欺詐、操縱或違反公司關於獎金計劃的協議、政策和條件的跡像或懷疑，將取消之前記入的所有獎金該帳戶和任何相關帳戶。在這種情況下，公司有權自行決定並在不減損其與客戶的協議和適用法律規定的權利的情況下，取消和取消所有進行的交易和/或由此產生的利潤或損失，並停止所有相關帳戶。且本公司對任何上述行為造成的後果不承擔任何責任。
             <br><br>
             公司保留自行酌情決定隨時更改、修改、暫停、取消或終止任何上述紅利或上述優惠的任何方面的權利。
          </p>`,
          data_id: "",
          content_after: "",
        },
        {
  //id: "margin_information",
  id: 'tc-view-24',
  title: "保證金資訊",
  content_before: `
    <p>
    下面顯示的視窗提供了與帳戶保證金相關的詳細資訊：
    <div class="table-wrapper">
      <table class="table3 mt-4 mb-4">
        <tbody>
          <tr>
            <td>總資產淨值</td>
            <td>$4,995</td>
          </tr>
          <tr>
            <td>已用保證金</td>
            <td>$2,500</td>
          </tr>
          <tr>
            <td>可用保證金</td>
            <td>$2,495</td>
          </tr>
          <tr>
            <td>保證金利用率</td>
            <td style="color:green">50.05%</td>
          </tr>
          <tr>
            <td>維持保證金</td>
            <td>$500</td>
          </tr>
          <tr>
            <td>淨敞口</td>
            <td>$250,000</td>
          </tr>
          <tr>
            <td>敞口覆蓋率</td>
            <td>1.80%</td>
          </tr>
        </tbody>
      </table>
    </div>
    <ul class="list-style-disc-small mb-3">
      <li><b>總資產淨值</b>反映您帳戶的即時價值。它包括您的餘額、未平倉部位的盈虧以及（如適用）任何添加到您帳戶的交易紅利。</li>
      <li><b>已用保證金</b>顯示帳戶中目前用於未平倉交易保證金的總資產淨值金額。若已使用保證金等於或大於總資產淨值，則表示帳戶槓桿已最大化。</li>
      <li><b>可用保證金</b>顯示帳戶中目前未使用且可用於進一步增加淨敞口的總資產淨值部分。當可用保證金為零時，表示帳戶已使用最大槓桿。<br>可用保證金 = 總資產淨值 - 已用保證金</li>
      <li><b>保證金利用率</b>顯示帳戶目前未平倉交易中用作保證金的總資產淨值部分百分比。100%及以上的保證金利用率表示帳戶中的最大槓桿使用率。<br>保證金利用率（%）=（已用保證金 / 總資產淨值）× 100</li>
      <li><b>維持保證金</b>等於維持未平倉交易所需已用保證金的20%。如果您的總資產淨值跌至或低於此水平，將自動觸發保證金平倉保護（定義見下文）。<br>維持保證金 = 已用保證金 × 由交易平台所定義的百分比（%）<br>iFOREX 保留自行決定設定和/或更改維持保證金的權利。</li>
      <li><b>敞口覆蓋率</b>是指資金覆蓋的風險敞口百分比。<br>它顯示了在資金支持下，市場價格可對持倉方向發生的最大逆向變動，直到達到維持保證金為止。<br>敞口覆蓋率 =（總資產淨值 - 維持保證金）/ 淨敞口</li>
    </ul>
    <b>強制平倉保護</b><br>若客戶的總資產淨值達到或低於維持保證金水平，iFOREX 將自動關閉消耗最多使用保證金的交易，以實現最低可能的維持保證金，僅影響在各自交易時段內開倉的交易。若當時無任何開倉交易，則第一個收到報價的交易將被自動關閉。若有多個交易（超過一筆）消耗相同的使用保證金，系統將自動關閉最早開倉的交易。若無法透過自動關閉單一交易達到最低維持保證金，iFOREX 將自動關閉特定交易下的所有開倉交易。
    <br>iFOREX 允許客戶使用未實現利潤來支援虧損的交易。
    <br><br>
    <b><u><u>強制平倉保護範例</u></u></b><br>
    在以下範例中，維持保證金 = 已用保證金 × 20%
    <br><br>
    <b>範例一：多筆交易（無交易紅利）</b><br>
    此範例為客戶持有多筆未平倉交易時，總資產淨值降至維持保證金水準的情形：<br><br>
    <ul class="list-style-disc-small mb-3">
      <li>未平倉交易：</li>
      <ul class="list-style-disc-small empty-disc ml-4">
        <li>買入 USD/JPY $200,000，價格 150.22（已用保證金 = 0.25% × $200,000 = $500）</li>
        <li>買入黃金 100 盎司，價格 2,300.00（已用保證金 = 0.5% × 100 × $2,300 = $1,150）</li>
        <li>買入 WTI 原油 500 桶，價格 70.00（已用保證金 = 1% × 500 × $70 = $350）</li>
      </ul>
      <li>已用保證金總額：$500 + $1,150 + $350 = $2,000</li>
      <li>維持保證金：$2,000 × 20% = $400</li>
    </ul>
    <p><b>處理過程：</b></p>
    <ol>
      <li>若總資產淨值降至 $400 或以下，系統將平倉黃金交易（佔用保證金最多），剩餘已用保證金為 $850，維持保證金降至 $170。</li>
      <li>若總資產淨值降至 $170 或以下，系統將平倉 USD/JPY，剩餘已用保證金為 $350，維持保證金降至 $70。</li>
      <li>若總資產淨值降至 $70 或以下，系統將平倉剩餘的 WTI 原油交易。</li>
    </ol>
    <b>範例二：單筆交易（含交易紅利）</b><br>
    此範例為客戶僅持有一筆交易並享有交易紅利時，總資產淨值降至或低於維持保證金的情況：<br><br>
    <ul class="list-style-disc-small mb-3">
      <li><b>入金：</b>$1,000（附加 100% 交易紅利）</li>
      <li><b>總資產淨值：</b>$2,000</li>
      <li><b>交易：</b>買入 USD/JPY $800,000</li>
      <li><b>已用保證金：</b>0.25% × $800,000 = $2,000</li>
      <li><b>維持保證金水準：</b>$400</li>
    </ul>
    <p><b>處理過程：</b>當未平倉損益為 -$1,600 或以下，總資產淨值降至 $400 時，系統將自動平倉該筆交易。</p>
    <b>範例三：多筆交易（含交易紅利）</b><br>
    客戶持有多個未平倉交易及交易紅利，總資產淨值等於或低於維持保證金。<br><br>
    <ul class="list-style-disc-small mb-3">
      <li><b>入金：</b>$1,000（附加 100% 交易紅利）</li>
      <li><b>資金：</b>$1,000</li>
      <li><b>交易紅利：</b>$1,000</li>
      <li><b>總資產淨值：</b>$2,000</li>
      <li><b>未平倉交易：</b></li>
      <ul class="list-style-disc-small empty-disc ml-4">
        <li>買入 USD/JPY $400,000，價格 150.22（已用保證金 = $1,000）</li>
        <li>買入 WTI 原油 1,000 桶，價格 85.00（已用保證金 = $850）</li>
      </ul>
      <li><b>總已用保證金：</b>$1,000 + $850 = $1,850</li>
      <li><b>維持保證金水準：</b>$1,850 × 20% = $370</li>
    </ul>
    <p><b>處理過程：</b></p>
    <ol>
      <li>當未平倉盈虧跌至 -$1,630 或以下時，總資產淨值達到維持保證金水準 $370，系統將平倉 USD/JPY。</li>
      <li>隨著 USD/JPY 交易的結束，已用保證金變為 $850，新的維持保證金水準為 $170（$850 × 20%）。</li>
      <li>總資產淨值跌至 $170 或以下，系統自動關閉 WTI 石油交易。</li>
    </ol>
    </p>
  `,
  data_id: "",
  content_after: "",
}
,
        {
          //id: "additional_trading_rules",
          id: "tc-view-25",
          title: "附加交易規則",
          content_before: `
              <p>
              
              <b>最大曝光</b><br>
              作為一項旨在更好地管理風險和避免對單個客戶過度敞口的審慎措施，iFOREX 設定了每位客戶最高 1千5百萬美元的最大淨敞口限制。 iFOREX 還為每種工具設定了最大淨敞口。要查看每種工具的最大敞口量，請<span class="tclink" target-tab="tc-view-6" target-section="product_section">單擊此處</span>。iFOREX 有權在任何特定時刻自行決定取消或更改此類限制，恕不另行通知。
              <br><br>
              <b>對沖</b><br>
              對沖被定義為在不同方向（一個“買入”，另一個“賣出”）對同一工具或標的資產進行兩次交易，無論是否同時進行，也無論數量是否相同。 iFOREX 視對沖交易是為了以累計或“淨值”為基礎計算最低保證金。此外，iFOREX 將一項對沖交易的結束視為一項新交易的開始，該交易的金額等於剩餘交易的金額。
              <br><br>
              <b>交易淨額</b><br>
              如果一個帳戶需要同時平倉多筆交易，iFOREX 將批量平倉所有未平倉頭寸。分配給每個已平倉頭寸的交易編號是根據先進先出規則設置的。這意味著在平倉時，第一個開倉將獲得最低的交易編號，最後一個開倉將獲得最高的交易編號。
              <br><br>
              <b>未經授權的交易行為</b><br>
              iFOREX 支持公平交易，不允許進行濫用交易的行為，例如滯後交易、價格操縱、時間操縱或任何其他非法和/或用於給客戶帶來不公平優勢的行為。此類禁止做法的示例可以是但不限於以下任何一種：
              <ul class="list-style-disc-small mt-3 mb-2">
                 <li>
                    <b>剝頭皮</b> 是一種試圖利用價格微小變化的交易策略。 實施此策略的交易者將創建許多短期頭寸，通常會在幾秒鐘或幾分鐘內平倉。
                 </li>
                 <li>
                    <b>自動化</b>（例如 EA）或算法交易是使用電子平台輸入帶有算法的交易訂單，該算法執行預編程的交易指令，其變量可能包括訂單的時間、價格或數量，或者在許多情況下啟動訂單由“機器人”完成，無需人工干預。
                 </li>
                 <li>
                    <b>API交易</b>是一種應用程序編程接口，是指使用軟件程序與其他程序交互的所有交易。 API 充當交易者和市場之間的中間人，根據需要傳遞訂單和檢索信息。
                 </li>
                 <li>
                    <b>“多個帳戶”</b>是指一個客戶設置兩個或多個帳戶以不誠實地從 iFOREX 獲得多個與帳戶相關的利益的情況。
                 </li>
              </ul>
              <p>如果公司察覺有任何跡像或懷疑，根據公司的唯一和絕對酌情權，以任何形式的剝削、非法、不公平、未經授權和/或濫用交易行為，用於給客戶不公平的優勢，和/或欺詐、操縱或違反公司的協議、政策、條款和條件，公司有權自行決定，在不減損其與客戶的協議和適用法律規定的權利的情況下，取消所有相關帳戶進行的交易，包括其中產生的所有利潤或損失，並取消授予客戶的任何獎金和/或凍結帳戶。</p>
              <b>費率錯誤</b><br>
              線上交易技術並不完美，在極少數情況下，可能會連線中斷。這可能只持續片刻，但一旦發生，價格往往會受到影響。雖然進行“套利交易”可能很誘人，但請記住，在這種情況下，價格並不能反映真實的市場價格，您的實際成交可能與顯示的價格相差很多點。如果交易的執行價格並非 iFOREX 實際提供的價格，iFOREX 保留撤銷此類交易的權利，因為它們不被視為有效交易。請記住，這些情況通常很少見，通過在這些時刻不進行交易，交易者可以避免與上述情況相關的風險。
              <br><br>
              <b>Vault 钱包</b><br>
              此功能使客戶能夠排除其帳戶中的可用資金，而此類資金不會受到帳戶交易活動的影響，並且根據客戶的判斷，可以在任何給定時間恢復以支援帳戶的交易保證金要求。本公司的客戶將自行決定是否允許使用 Vault 錢包。若 Vault 錢包可供客戶使用，則適用下列條款： (i) 本公司授予的獎金不能分配給 Vault錢包； (ii) 資金返還至客戶帳戶的金額將按照最初分配給 Vault 的金額進行，而不是一次性全部累積金額（例如，如果客戶向 Vault 錢包分配了 50 美元，然後又分配了 100 美元，則客戶將無法立即恢復150 美元，而是分別恢復最初分配的不同金額）； (iii) 如果帳戶變得不活躍，Vault錢包中的所有可用資金將由公司自動恢復至帳戶淨值，並根據客戶協議第 13.3 條的條款扣除不活躍費用； (iv) 本公司保留在其認為適當的情況下拒絕使用 Vault錢包、更改和更新其使用條款以及取消其使用的權利。
              <br><br>
              <b>不活躍費用</b><br>
              連續十二 (12) 個月沒有交易活動的客戶帳戶可能會被收取 15 美元的季度不活躍費用，如果淨值低於 15 美元，則按帳戶的全部淨值收取。
              <br><br>
              <b>貨幣兌換費</b><br>
              以與客戶交易帳戶貨幣不同的貨幣交易金融工具可能會使該客戶面臨貨幣兌換費。
              <br><br>
              使用信用卡以交易帳戶貨幣以外的貨幣從交易帳戶注資或提取資金可能需要支付客戶信用卡公司收取的兌換費。
              <br><br>
              <b>某些受限制國家/地區將不可用且無法訪問交易服務</b><br>
              某些受限制國家（包括但不限於美國）將無法提供或提供交易平台和/或交易服務。有關使用或訪問某些受限制國家/地區的公司服務或網站的限制（包括受限制國家/地區列表）的更多信息，請單擊<a href="/legal/restricted-countries" target="_blank" rel="noopener">此處</a>。
              <br><br>
              有關交易的更多信息，請參閱我們的<a href="/legal/client_agreement.pdf" target="_blank" rel="noopener">客戶協議</a>。
              </p>
              `,
          data_id: "",
          content_after: "",
        },
      ],
    },
    {
      id: "forex",
      title: "外匯",
      tabs: [
        {
          //id: "forex_overnight_financing",
          id: "tc-view-10",
          title: "隔夜融資",
          content_before: `
                  <p>
                  在 iFOREX 交易槓桿外匯差價合約時，您的未平倉交易在每個交易日結束時都將收取隔夜費。這種隔夜融資可能需要貸記或借記，根據交易標的貨幣的相關利率加上加價計算。貨幣對的加價從 0.75% 開始，並且可以更高，並且在多頭（買入）和空頭（賣出）頭寸之間存在差異。請查看下表了解最新的隔夜融資水平。
                  <br><br>
                  如果計算的隔夜融資百分比為正數，則意味著將向您的帳戶餘額添加（貸記）相應金額。負的隔夜融資百分比意味著將從您的帳戶餘額中扣除（借記）相應的金額。
                  <br><br>
                  您可以在“市場信息”選項卡的“工具”下的“交易”和“限價”表格中找到相關的隔夜融資百分比、金額及其相關運行時間。要計算您的帳戶為借記或貸記的隔夜融資，只需將隔夜融資百分比乘以您的交易規模。每個差價合約的隔夜融資流程的運行時間在交易表格“隔夜融資 (GMT)”下的“工具信息工具”中詳細說明。工具隔夜融資的計算值和百分比適用於 1 天。每週交易 5 天的差價合約將在其標的資產交易週的最後一天以顯示價值的 3 倍計入貸記或借記，因為它涵蓋了整個週末期間。隔夜融資金額根據差價合約的幣種報價。但是，如果報價差價合約的幣種與帳戶幣種不同，它將轉換為帳戶貨幣。
                  <br><br>
                  <u><b><u>公式</u></b></u><br><br>
                  買入時隔夜融資百分比的計算（多頭頭寸）：
                      <br>
  
                    <div class="formula formula_f1 mb-3">
                        <div class="formula-name">隔夜融資百分比</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">其他貨幣的利率 - 基本貨幣的利率 + 長期附加費</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>
                  
                    賣出（空頭頭寸）時隔夜融資百分比的計算：
                      <br><br>
                      
                      <div class="formula formula_f2">
                        <div class="formula-name">隔夜融資百分比</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">其他貨幣的利率 - 基本貨幣的利率 - 短期附加費</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>

                      <br><br>

                      要計算隔夜融資金額，只需將百分比乘以交易金額：<br><br>隔夜融資金額=交易金額×隔夜融資百分比
                        <br><br><br>
                        <u><b><u>例子</u></b></u><br><br>
                        <b>例子一</b><br><br>
                        此示例涉及銀行同業拆息率高於加價的情況。在這種情況下，當您做多時，您的帳戶將被借記，當您做空時，您的帳戶將被貸記：
                        <br><br>
                        <ul class="list-style-dashed mb-4">
                            <li>工具 = EUR/USD（歐元兌美元）</li>
                            <li>EUR（基準貨幣）利率（年化）= -0.37% = -0.0037</li>
                            <li>USD（其他貨幣）利率（年化）= 1.08% = 0.0108</li>
                            <li>銀行同業拆息差 = 1.45% = 0.0145</li>
                            <li>做多加價 = 0.75% = 0.0075</li>
                            <li>做空加價 = 0.75% = 0.0075</li>
                            <li>交易金額價值 = 106,550 美元（100,000 歐元的當前收盤價為 1.0655）</li>
                        </ul>
                        買入時的隔夜融資百分比（多頭頭寸）：<br><br>
                      
                    <div class="formula formula_f3 mb-2" >
                        <div class="formula-name">隔夜融資百分比</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) + 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.0000611</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.00611%</div>
                    </div>

                    隔夜融資金額 = 106,550 × (-0.0000611) = -6.51 美元，即每天收取 6.51 美元的費用
                    <br><br><br>
                    賣出時的隔夜融資百分比（空頭頭寸）：<br><br>
                      
                      <div class="formula formula_f4 mb-2" >
                        <div class="formula-name">隔夜融資百分比</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) - 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">0.00001944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">0.001944%</div>
                    </div>

                    隔夜融資金額 = 106,550 × 0.00001944 = 每天 2.07 美元
                    <br><br><br>
                    <b>例子二</b><br><br>
                    此示例涉及銀行同業拆息率高於加價且多頭和空頭加價不同的情況。在這種情況下，當您做多時，您的帳戶將被借記，當您做空時，您的帳戶將被貸記：
                    <br><br>
                    <ul class="list-style-dashed mb-4">
                       <li>工具 = EUR/TRY（歐元兌土耳其里拉）</li>
                       <li>EUR（基準貨幣）利率（年化）= -0.37% = -0.0037</li>
                       <li>TRY（其他貨幣）利率（年化）= 22.75% = 0.2275</li>
                       <li>銀行同業拆息差= 23.12% = 0.2312</li>
                       <li>做多加價 = 0.75% = 0.0075</li>
                       <li>做空加價 = 14.00% = 0.14</li>
                       <li>交易金額價值 = 620,000 土耳其里拉（100,000 歐元，當前收盤價為 6.2000）</li>
                    </ul>
                    買入時的隔夜融資百分比（多頭頭寸）：<br><br>
                      
                        <div class="formula formula_f5 mb-2" >
                            <div class="formula-name">隔夜融資百分比</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.000663</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.0663%</div>
                        </div>

                    
                        隔夜融資金額 = 620,000 × (-0.000663) = -411 TRY，即每天收取 411 TRY 費用（≅80 美元）
                        <br><br><br>
                        賣出時的隔夜融資百分比（空頭頭寸）：<br><br>
                      
                      <div class="formula formula_f6 mb-2" >
                            <div class="formula-name">隔夜融資百分比</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) - 0.14</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.000253</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.0253%</div>
                        </div>


                        隔夜融資金額 = 620,000 × (0.000253) = 157 TRY，即每天 157 TRY 信用額度（≅30 美元）
                        <br><br><br>
                        <b>例子三</b><br><br>
                        此示例涉及銀行同業拆息率低於負加價的情況。在這種情況下，當您做空時，您的帳戶將被借記，當您做多時，您的帳戶將被記入貸方：
                        <ul class="list-style-dashed mt-4 mb-4">
                           <li>工具 = USD/JPY（美元兌日元）</li>
                           <li>USD（基準貨幣）利率（年化）= 1.08% = 1.08</li>
                           <li>JPY（其他貨幣）利率（年化）= -0.09% = -0.0009</li>
                           <li>銀行同業拆息差 = -1.17% = -0.0117</li>
                           <li>做多加價 = 0.75% = 0.0075</li>
                           <li>做空加價 = 0.75% = 0.0075</li>
                           <li>交易金額價值 = 10,341,000 日元（100,000 美元，當前收盤價為 103.41）</li>
                        </ul>
                        買入時的隔夜融資百分比（多頭頭寸）：<br><br>
                      
                      
                      <div class="formula formula_f7 mb-2" >
                            <div class="formula-name">隔夜融資百分比</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.00001167</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.001167%</div>
                        </div>


                        隔夜融資金額 = 10,341,000 ×0.00001167=120.65 日元信用額度（≅1.1 美元）
                        <br><br><br>
                        賣出時的隔夜融資百分比（空頭頭寸）：<br><br>
                      
                      <div class="formula formula_f8 mb-2" >
                            <div class="formula-name">隔夜融資百分比</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 - 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.0000533</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.00533%</div>
                        </div>

                        隔夜融資金額 = 10,341,000 ×(-0.0000533)=-551.52 日元，即每天收費 551.52 日元（≅5.3 美元）
                     
                      
                   
                  </p>`,
  
          data_id: "OvernightFinancing",
          content_after: `<p>* 隔夜融資結算在交易日結束時可能需要長達 15 分鐘的時間來處理，之後您的帳戶將被適當地貸記或借記。</p>`,
          table_titles: [
            "工具",
            "每日隔夜融資百分比（賣出）",
            "每日隔夜融資百分比（買入）",
            "隔夜融資 (GMT)*",
          ],
          view_id: ["Forex"],
        },
      ],
    },
    {
      id: "index_commodity_and_crypto_cfds",
      title: "指數、商品和加密貨幣差價合約",
      tabs: [
        {
          //id: "index_overnight_financing",
          id: "tc-view-11",
          title: "隔夜融資",
          content_before: `
              <p>
              當使用 iFOREX 交易指數、商品和加密貨幣差價合約時，您的未平倉交易將在每個交易日結束時進行隔夜融資，該隔夜融資可能會記入貸方或借方，根據所在貨幣的相關利率計算基礎工具進行交易並加價。 由於加密貨幣的極端市場條件，加密貨幣的加價可能會明顯更高。 請查看下表以了解最新的隔夜融資水準。
              <br><br>
              如果計算的隔夜融資百分比為正數，則意味著將向您的帳戶餘額添加（貸記）相應金額。負的隔夜融資百分比意味著將從您的帳戶餘額中扣除（借記）相應的金額。
              <br><br>
              您可以在“市場信息”選項卡的“工具”下的“交易”和“限價”表格中找到相關的隔夜融資百分比、金額及其相關運行時間。要計算您的帳戶將被借記或貸記的隔夜融資，只需將隔夜融資百分比乘以您的交易規模。每個差價合約的隔夜融資流程的運行時間在交易表格“隔夜融資 (GMT)”下的“工具信息工具”中詳細說明。工具隔夜融資的計算值和百分比適用於 1 天。每週交易 5 天的差價合約將在其標的資產交易週的最後一天以顯示價值的 3 倍貸計或借記，因為它涵蓋了整個週末期間。隔夜融資金額根據差價合約的貨幣報價。但是，如果報價差價合約的貨幣與帳戶貨幣不同，它將轉換為帳戶貨幣。
              <br><br>
              <u><b><u>公式</u></b></u><br><br>
              買入時隔夜融資百分比的計算（多頭頭寸）：<br>
                  
                  <div class="formula formula_f9 mb-3">
                    <div class="formula-name">隔夜融資百分比</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">利率 + 加價</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>

                賣出（空頭頭寸）時隔夜融資百分比的計算：<br><br>
                  
                  <div class="formula formula_f10 mb-2">
                    <div class="formula-name">隔夜融資百分比</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">利率 - 加價</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>

                要計算隔夜融資金額，只需將百分比乘以交易金額：<br><br>隔夜融資金額=交易金額×隔夜融資百分比
                <br><br><br>
                <u><b><u>例子</u></b></u><br><br>
                <b>例子一</b><br><br>
                此示例涉及 銀行同業拆息率高於加價的情況。在這種情況下，當您做多時，您的帳戶將被借記，當您做空時，您的帳戶將被貸記：
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>工具 = 巴西 Ibovespa</li>
                   <li>巴西雷亞爾 (BRL) 利率（年化）= 9.567% = 0.09567</li>
                   <li>加價 = 2.5% = 0.025</li>
                   <li>交易金額價值 = 127,380 BRL（2 份指數合約，當前收盤價為每份合約 63690 BRL）</li>
                </ul>
           
                買入時的隔夜融資百分比（多頭頭寸）：<br><br>
                  
                  <div class="formula formula_f11 mb-2">
                    <div class="formula-name">隔夜融資百分比</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 + 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0003351944</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.03351944%</div>
                </div>

                隔夜融資金額 = 127,380 × (-0.0003351944) = -42.70 BRL，即每天收取 42.70 BRL（≅13.58 美元）
                <br><br><br>
                賣出時的隔夜融資百分比（空頭頭寸）：<br><br>
                  
                  <div class="formula formula_f12 mb-2">
                    <div class="formula-name">隔夜融資百分比</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 - 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.00019630556</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.019630556%</div>
                </div>

                隔夜融資金額 = 127,380 × 0.00019630556 = 每天 25 BRL (≅7.95 美元)
                <br><br><br>
                <b>例子二</b><br><br>
                此示例涉及銀行同業拆息率低於加價的情況。在這種情況下，無論您的頭寸方向如何，每晚都會從您的帳戶中扣除：
                <br><br>
                <ul class="list-style-dashed">
                   <li>工具 = 石油（原油 WTI）</li>
                   <li>美元 (USD) 利率（年化）= 1.08% = 0.0108</li>
                   <li>加價 = 2.5% = 0.025</li>
                   <li>交易金額價值 = 53,250 美元（1,000 桶石油，當前收盤價為每桶 53.25 美元）</li>
                </ul>
                <br><br>
                買入時的隔夜融資百分比（多頭頭寸）：<br><br>

                  <div class="formula formula_f13 mb-2">
                        <div class="formula-name">隔夜融資百分比</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 + 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00009944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.009944%</div>
                    </div>

                    隔夜融資金額 = 53,250 × (-0.00009944) = -5.30 美元，即每天收取 5.30 美元的費用
                    <br><br><br>
                    賣出時的隔夜融資百分比（空頭頭寸）：<br><br>
                  
                  <div class="formula formula_f14 mb-2">
                        <div class="formula-name">隔夜融資百分比</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00003944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.003944%</div>
                    </div>

                    隔夜融資金額 = 53,250 × (-0.00003944) = -2.10 美元，即每天收取 2.10 美元的費用
                  <br><br>
                  
                 
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* 隔夜融資結算在交易日結束時可能需要長達 15 分鐘的時間來處理，之後您的帳戶將被適當地貸記或借記。</p>`,
          table_titles: [
            "工具",
            "每日隔夜融資百分比（賣出）",
            "每日隔夜融資百分比（買入）",
            "隔夜融資 (GMT)*",
          ],
          view_id: ["Index", "Commodity", "Crypto"],
        },
        {
        //id: "contracts_rollover_dates",
        id: "tc-view-3",
          title: "合約展期日期",
          content_before: `<p>
                        每個基於未來合約（即商品和指數）的差價合約都有一個展期日期。
                        <br><br>
                        到達相關工具的展期日期後，所有未平倉期貨合約差價合約頭寸將展期至下一個合約，因此該頭寸仍與新的未來合約保持開放。
                        <br><br>
                        執行此類展期後，頭寸的未平倉盈虧（盈虧）將表示到期合約價格與新合約價格之間的差價，並包含加價差價。所有相關的限價單水平將根據新的未來合約價格自動調整。
                        <br><br>
                        例如，如果 WTI 石油 2 月合約的最後價格為 50.125 美元，而隨後的合約（3 月）當時的市場價格為 50.805 美元，則所有未平倉限價單的價格水平將向上更新 0.68 美元。
                      <br><br>
                      合約的展期日期取決於您交易的工具。以下列出的是適用於唯一展期日期的 iFOREX 差價合約：
                  </p>`,
  
          data_id: "FuturesRollover",
          content_after: ``,
          table_titles: ["合約月份", "合約展期 (GMT)"],
          view_id: ["Commodity", "Index"],
          products: ["大宗商品", "指數"],
        },
      ],
    },
    {
      id: "Share and ETF CFDs",
      title: "股票和 ETF 差價合約",
      tabs: [
        {
          //id: "shares_overnight_financing",
          id: "tc-view-12",
          title: "隔夜融資",
          content_before: `<p>
                        當使用 iFOREX 交易股票和 ETF 差價合約時，您的未平倉交易將在每個交易日結束時進行隔夜融資，該隔夜融資可能會記入貸方或借方，根據所在貨幣的相關利率計算基礎工具進行交易，並加價。 請查看下表以了解最新的隔夜融資水準。
                        <br><br>
                        如果計算的隔夜融資百分比為正數，則意味著將向您的帳戶餘額添加（貸記）相應金額。負的隔夜融資百分比意味著將從您的帳戶餘額中扣除（借記）相應的金額。
                        <br><br>
                        您可以在“市場信息”選項卡的“工具”下的“交易”和“限價”表格中找到相關的隔夜融資百分比、金額及其相關運行時間。要計算您的帳戶將被借記或貸記的隔夜融資，只需將隔夜融資百分比乘以您的交易規模。每個差價合約的隔夜融資流程的運行時間在交易表格“隔夜融資 (GMT)”下的“工具信息工具”中詳細說明。工具隔夜融資的計算值和百分比適用於 1 天。每週交易 5 天的差價合約將在其標的資產交易週的最後一天以顯示價值的 3 倍貸記或借記，因為它涵蓋了整個週末期間。隔夜融資金額根據差價合約的貨幣報價。但是，如果報價差價合約的貨幣與帳戶貨幣不同，它將轉換為帳戶貨幣。
                        <br><br>
                        <u><b><u>公式</u></b></u><br><br>
                        買入（多頭頭寸）時隔夜融資百分比的計算：
                  
                  <br>
                  
                  <div class="formula formula_f15 mb-3">
                    <div class="formula-name">隔夜融資百分比</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">利率 + 加價</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>

                賣出（空頭頭寸）時隔夜融資百分比的計算：

                <br><br>

                <div class="formula formula_f16 mb-2">
                    <div class="formula-name">隔夜融資百分比</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">利率 - 加價</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>


                要計算隔夜融資金額，只需將百分比乘以交易金額：<br><br>隔夜融資金額=交易金額×隔夜融資百分比
                <br><br><br>
                <u><b><u>例子</u></b></u><br><br>
                <b>例子一</b><br><br>
                此示例涉及銀行同業拆息率高於加價的情況。在這種情況下，當您做多時，您的帳戶將被記入借方，而當您做空時，您的帳戶將被記入貸方：
                <br><br>
                <ul class="list-style-dashed">
                   <li>工具 = Gazprom (GAZP)</li>
                   <li>俄羅斯盧布 (RUB) 利率（年化）= 9.5% = 0.095</li>
                   <li>加價 = 5% = 0.05</li>
                   <li>交易金額價值 = 2,459,000 RUB（20,000 股，按每股 122.95 盧布的當前收盤價計算）</li>
                </ul>
                <br><br>
                買入時的隔夜融資百分比（多頭頭寸）：<br><br>
                  
                  
                <div class="formula formula_f17 mb-2">
                    <div class="formula-name">隔夜融資百分比</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0004</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.04%</div>
                </div>

                隔夜融資金額 = 2,459,000 × (-0.0004) = -983.60 RUB，即每天收取 983.60 RUB (≅17.52 美元)
                <br><br><br>
                賣出時的隔夜融資百分比（空頭頭寸）：<br><br>

                  <div class="formula formula_f18 mb-2">
                    <div class="formula-name">隔夜融資百分比</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.000125</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.0125%</div>
                </div>


                隔夜融資金額 = 2,459,000 × 0.000125 = 307.38 盧布信用額度（≅5.48 美元）
                <br><br><br>
                <b>例子二</b><br><br>
                此示例涉及銀行同業拆借利率低於加價的情況。在這種情況下，無論您的頭寸方向如何，每晚都會從您的帳戶中扣除：
                <br><br>
                <ul class="list-style-dashed">
                    <li>工具 = Apple (AAPL)</li>
                    <li>美元 (USD) 利率（年化）= 1.08% = 0.0108</li>
                    <li>加價 = 5% = 0.05</li>
                    <li>交易金額價值 = 70,600 美元（500 股，按當前收盤價每股 141.20 美元計算）</li>
                </ul>
                <br>
                買入時的隔夜融資百分比（多頭頭寸）：<br><br>

                  <div class="formula formula_f19 mb-2">
                    <div class="formula-name">隔夜融資百分比</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000169</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0169%</div>
                </div>
                  
                隔夜融資金額 = 70,600 × (-0.000169) = -11.93 美元，即每天收取 11.93 美元的費用
                <br><br><br>
                賣出時的隔夜融資百分比（空頭頭寸）：<br><br>
                  
                <div class="formula formula_f20 mb-2">
                    <div class="formula-name">隔夜融資百分比</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000109</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0109%</div>
                </div>


                隔夜融資金額 = 70,600 × =-0.000109) = -7.70 美元，即每天收取 7.70 美元的費用
            
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* 隔夜融資結算在交易日結束時可能需要長達 15 分鐘的時間來處理，之後您的帳戶將被適當地貸記或借記。</p>`,
          table_titles: [
            "工具",
            "每日隔夜融資百分比（賣出）",
            "每日隔夜融資百分比（買入）",
            "隔夜融資 (GMT)*",
          ],
          view_id: [ "Shares", "ETF"],
        },
        {
          //d: "dividends",
          id: "tc-view-7",
          title: "股息",
          content_before: `<p>
                        如果就股票差價合約分配現金股息，將根據客戶在除息前一個工作日結束時持有的相關股票差價合約頭寸對客戶餘額進行股息調整。股息調整應根據股息的大小、客戶的倉位大小以及是買入還是賣出交易來計算。在多頭頭寸中，調整應記入客戶餘額，在空頭頭寸中，調整應從客戶餘額中扣除。股息應在相關股票交易時間以外和股票下一個交易日開市前從客戶餘額中貸記或借記，並視客戶在股息調整時持有的各自頭寸而定。在此期間，為保持客戶權益的公允價值直至下一個交易日開市，本公司將根據客戶餘額中借記或貸記的股息金額調整客戶頭寸。
                        <br><br>
                        <u>例子:</u><br>
                        可口可樂發行每股 0.35 美元的股息。<br>
                        除息日為 11 月 29 日，iFOREX 的結算日為 11 月 28 日格林威治標準時間 22:05。<br>
                        結算前收盤價為41.65。<br>
                        持有 5,000 股多頭頭寸的客戶如果在結算日交易未平倉，將獲得 0.35 x 5,000 = 1,750 美元。
                        <br>
                        如果客戶持有空頭頭寸，將從該客戶交易帳戶的餘額中扣除相應的金額。
                        <br>
                        盤後股價將由 41.65 調整至 41.30，等於最後股價減去股息金額。
                      </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"目前沒有關於未來股息的資訊",
          table_titles: [
            "股票/ETF",
            "市場",
            "股息金額",
            "日期和時間 (GMT)",
          ],
          view_id: "1",
        },
        {
          //id: "corporate_actions",
          id: "tc-view-1",
          title: "股票股利、股票分割及其他公司行為",
          content_before: `<p>
                        公司行為是影響上市公司股票價值的某些事件。除非本文就特定公司行為另有規定，否則在特定股票發生公司行為時，iFOREX 應清算相關差價合約的任何未平倉頭寸，包括在需要時取消任何限價單此類差價合約的 (s)。
                        <br><br>
                        iFOREX 中的公司行為包括供股、退市和任何其他對股票價格產生重大影響或可能產生重大影響的事件（包括重大公司公告、收購、合併、破產等）。
                        <br><br>

                        <b>股票股利</b><br>

                        交易所的股票股利不會改變持有者股票的總價值，而是改變股票的數量和價格。<br>
                        您將收到所持有的每股的「調整係數」。<br>
                        在股票股利日期間，您的任何未平倉交易和/或限價單的數量、價格及相關限價將相應調整（包括帳戶餘額因所需的損益調整而發生的變化）。<br>
                        例如，在股票調整中，調整係數為1.8的情況下，1股在事件後變為1.8股，價格除以1.8，股票總價值保持不變。<br>
                        例如：1股價格為1,000美元，在事件後變為1.8股，每股價格為555.56美元: 1×1,000美元 = 1.8×555.56美元 = 1,000美元價值。<br><br>


                        <strong>
                        股票分割和反向股票分割的具體規則
                        </strong>
                        <br>
                        交易所的股票拆分和反向股票拆分不會改變持有股票的人的股票總價值，而是會改變股票的數量和價格。這些拆分通常在股價過高或過低時實施。如果未平倉交易/限價遇到股票拆分，其數量、比率和相關限價水平將相應調整。（包括帳戶餘額也可能及需求進行相應 PL 調整）。
                        <br><br>
                        例如，在 1:10 拆分中，1 只股票在事件發生後變成 10 只股票，價格除以 10，股票的整體價值不變。例如，價格為 1,000 美元的 1只股票在事件發生後將變成 10 只價格為 100 美元的股票：1x 1,000 美元 = 10 x 100 美元 = 1,000 美元的價值。
                        <br><br>
                        請在下面找到即將採取的公司行為的列表：
              </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"目前沒有關於未來公司行為的信息",
          table_titles: ["股票/ETF", "市場", "類型", "日期和時間 (GMT)"],
        },
        {
          //id: "earnings_reports",
          id: "tc-view-22",
          title: "收益報告",
          content_before: `<p>
                                收益報告是上市公司定期提交的報告其業績的文件。透過分析季度收益報告，投資者可以分析公司的財務狀況。該公司的獲利公佈，尤其是高市值的熱門公司，可能會影響其股價，從而導致其在發布季度獲利報告的日子裡出現大幅波動。
                                  <br><br>
                                  因此，在整個發布期間，相關股票的最大風險敞口將降至 10,000 美元。
                              </p>`,
          data_id: "",
          content_after: "",
        },
      ],
    },
  ];
  
  export { content };
  